<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0" >#</th>
        <th scope="col" class="text-left border-0">Tipo</th>
        <th scope="col" class="text-left border-0">Titulo</th>
        <th scope="col" class="text-left border-0">Usúario</th>
        <th scope="col" class="text-left border-0" v-if="showProject">Obra</th>
        <th scope="col" class="border-0">Status</th>
        <th scope="col" class="border-0">Aberto em</th>
        <th scope="col" class="border-0">Fechado em</th>
        <th scope="col" class="border-0"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(ticket, index) in tickets" :key="index">
        <td :class="['border-color', 'border-color-'+ ticket.status_slug]" :style="checkStatus(ticket)">{{ ticket.id }}</td>
        <td class="text-left">{{ (ticket.type) ? ticket.type.name : '' }}</td>
        <td class="text-left link">
          <d-link :to="{ name: 'admin-ticket-edit', params: { ticketId: ticket.id }}">{{ ticket.title }}</d-link>
        </td>
        <td class="text-left">{{ (ticket.user) ? ticket.user.name : '' }}</td>
        <td class="text-left link" v-if="showProject">
          <d-link :to="{ name: 'admin-project-edit', params: { projectId: ticket.project_id }}" v-if="ticket.project">{{ ticket.project.label }}</d-link>
        </td>
        <td :class="['color-'+ ticket.status_slug]" :style="{color: (ticket.status_slug === 'closed' ? '' : ticket.color )}">{{ ticket.status }}</td>
        <td>{{ ticket.opened }}</td>
        <td>{{ ticket.closed }}</td>
        <td class="text-center">
          <span class="d-block date" :style="{background: ticket.color}"></span>
        </td>
      </tr>
      <tr v-if="tickets.length === 0">
        <td colspan="9" class="no-content">Ainda não foi cadastrado nenhum chamado.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  name: 'ticket-table-list',
  props: {
    tickets: {
      type: Array,
    },
    showProject: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    checkStatus(ticket) {
      if (ticket.status_slug === 'closed') {
        return null;
      }
      return { borderLeftColor: ticket.color };
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';

.date {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 auto;
}

$size: 10px;
.border-color {
  border-left: $size solid $red;
  &-new {
    border-left-color: $red;
  }
  &-open {
    border-left-color: $orange;
  }
  &-progress {
    border-left-color: $yellow;
  }
  &-resolved {
    border-left-color: $green;
  }
  &-closed {
    border-left-color: $blue;
  }
}

.color{
  &-new {
    color: $red;
  }
  &-open {
    color: $orange;
  }
  &-progress {
    color: $yellow;
  }
  &-resolved {
    color: $green;
  }
  &-closed {
    color: $blue;
  }
}
.td-3 {
  width: 120px;
}
</style>
